import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';

import ic_add_brother_popup from './../../../src/assets/family/ic_add_brother_popup.PNG'
import ic_add_daughter_popup from './../../../src/assets/family/ic_add_daughter_popup.PNG'
import ic_add_father_popup from './../../../src/assets/family/ic_add_father_popup.PNG'
import ic_add_mother_popup from './../../../src/assets/family/ic_add_mother_popup.PNG'
import ic_add_pet_popup from './../../../src/assets/family/ic_add_pet_popup.PNG'
import ic_add_sister_popup from './../../../src/assets/family/ic_add_sister_popup.PNG'
import ic_add_son_popup from './../../../src/assets/family/ic_add_son_popup.PNG'
import ic_add_wife_popup from './../../../src/assets/family/ic_add_wife_popup.PNG'
import ErrorDialog from "./ErrorDialog";
import {
	API_BASE_URL,
	API_KEY,
  } from '../../constants';

import './Dialog.css'
import axiosInstance from "../../axios";

 export default function TestDialog({open,setOpen,memberId,memberName,clickedMemberRelativeDetails}) {
	// const [open, setOpen] = React.useState(false);
	const [openErrorDialog, setOpenErrorDialog] = React.useState(false);
	const [ErrorMessage,setErrorMessage]= React.useState(false);

	const handleClickToOpen = () => {
		setOpen(true);
	};

	const handleToClose = () => {
		setOpen(false);
	};
	const startBlinkingForMembers=(memberIds) => {
		memberIds.forEach(memberId => {
		  // Select the card element that matches the specific data-id
		  const cardElement = document.querySelector(`.card[data-id="${memberId}"]`);
		  
		  // If the card element is found, add the blinking class to its outline
		  if (cardElement) {
			const outlineElement = cardElement.querySelector('.card-outline'); // Base outline element
			if (outlineElement) {
			  outlineElement.classList.add('card-blink-outline'); // Add blinking class
	  
			  // Stop blinking after 10 seconds (optional)
			  setTimeout(() => {
				outlineElement.classList.remove('card-blink-outline');
			  }, 10000); // 10 seconds
			}
		  }
		});
	  }
	const handleClick = (e,value) => {
		handleToClose();
		const baseUrl = window.location.origin;
		const logged_in_user_obj=JSON.parse(localStorage.getItem('userData'))
		const logged_in_user_id=logged_in_user_obj.user_profile.member_id
		let url=""
		if(value=="edit"){
			url=`${baseUrl}/${memberId}/edit-member/`;
			window.location.href = url;
		}
		else if(value=="remove"){
			url=`${API_BASE_URL}delete-member/${memberId}`;
			
			axiosInstance.delete(url).then((response)=>{
			const responseData=response.data
			let message=""
			let memberIds = [];
			if(responseData.data.length>0){
				responseData.data.map(function(message_obj){
					if (!memberIds.includes(message_obj.member_id)) {
						memberIds.push(message_obj.member_id); // Add the new member ID to the list
					  }
					message=message+"<div style='text-align: left;'><li>"+message_obj.message+"</li></div></br>";
				})
				message="<div style='text-align: left;'>Member can't be deleted due to following dependency:</div><ol>"+message+"</ol><p> Please delete above dependents in order to delete the member!</p>"
				console.log(message)
				startBlinkingForMembers(memberIds)
				// setErrorMessage(message)
				// setOpenErrorDialog(true)
			}
			else{
				const path = "webtree";
				url=`${baseUrl}/${path}/${logged_in_user_id}`;
				window.location.href = url;
			}
		});
		}
		else if(value=='create_admin'){
			console.log(logged_in_user_obj.user_profile)
			console.log(logged_in_user_obj.user_profile.is_superuser)
			if(logged_in_user_obj.user_profile.is_superuser)
			{
				
				axiosInstance.post(
					`${API_BASE_URL}create-admin/`+memberId,{},
					{
					  headers: {
						'X-Api-Key': API_KEY
					  },
					}
				  ).then((response)=>
					{
						setErrorMessage("Assigned admin role. New admin will be able to edit members now.");
						setOpenErrorDialog(true);
						setTimeout(() => {
							const path = "webtree";
							url=`${baseUrl}/${path}/${logged_in_user_id}`;
							window.location.href = url;
						}, 5000);
						
					}
				);
			}
			else{
				setErrorMessage("You need to be a super user to assign admin role to members.")
				setOpenErrorDialog(true)
			}
		}
		else if(value=='revoke_admin'){
			console.log(logged_in_user_obj.user_profile)
			console.log(logged_in_user_obj.user_profile.is_superuser)
			if(logged_in_user_obj.user_profile.is_superuser)
			{
				
				axiosInstance.post(
					`${API_BASE_URL}create-admin/`+memberId,{"revoke":true},
					{
					  headers: {
						'X-Api-Key': API_KEY
					  },
					}
				  ).then((response)=>
					{
						setErrorMessage("Revoked admin access. Selected user will be able to edit only members created by him/her.");					
						setOpenErrorDialog(true);
						setTimeout(() => {
							const path = "webtree";
							url=`${baseUrl}/${path}/${logged_in_user_id}`;
							window.location.href = url;
						}, 5000);
						
					}
				);
			}
			else{
				setErrorMessage("You need to be a super user to revoke admin role to members.")
				setOpenErrorDialog(true)
			}
		}
		else{
			if((value=="Brother" || value=="Sister") && !clickedMemberRelativeDetails.father && !clickedMemberRelativeDetails.mother){
				alert("Sorry, you can't add sibling for "+memberName+" as member doesnot have any parents. Please add a parent of " +memberName+" to add sibling.")
			}
			else{
				const path = "member-add";
				url=`${baseUrl}/${path}/?associated_member=${memberId}&associated_member_name=${memberName}&relation=${value}`;
				window.location.href = url;
			}
		}
	};

	return (
		<div stlye={{}}>
			<Dialog open={open} onClose={handleToClose}>
				<IconButton style={{cursor:'pointer',left:'92%', marginTop: '5px', width: '20px'}} onClick={handleToClose}>
				<CloseIcon />
				</IconButton>
				<DialogTitle>{"Choose Action"}</DialogTitle>
				
				<DialogActions>
				<div className="all">
					<div className="symbols">
						<div >
							<Button onClick={(e) => {handleClick(e, "Father");}}
						color="primary" >
							<figure>

							<img src={ic_add_father_popup} alt=""   style={{ width: '60px', height: '60px' }} />
							<figcaption>Add Father</figcaption>
							<input type="hidden" value="father"/>
							</figure>

							</Button>
						</div>
						<div >
							<Button onClick={(e) => {handleClick(e, "Husband");}}
						color="primary" >
							<figure>
							<img src={ic_add_father_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
							<figcaption>Add Husband</figcaption>
							</figure>
							</Button>
							</div>
						<div >
							<Button onClick={(e) => {handleClick(e, "Brother");}}
						color="primary" >
							<figure>
							<img src={ic_add_brother_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
							<figcaption>Add Brother</figcaption>
							</figure>
						</Button>
						</div>
						<div >
							<Button onClick={(e) => {handleClick(e, "Son");}}
							color="primary" >
								<figure>
								<img src={ic_add_son_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
								<figcaption>Add Son</figcaption>
								</figure>
								</Button>
							</div>
						<div >
							<Button onClick={(e) => {handleClick(e, "edit");}}
					color="primary" >
						<figure>
						<img src={ic_add_brother_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
						<figcaption>Edit Member</figcaption>
						</figure>
							</Button>
						</div>
						<div >
							<Button onClick={(e) => {handleClick(e, "create_admin");}}
					color="primary" >
						<figure>
						<img src={ic_add_brother_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
						<figcaption>Make Admin</figcaption>
						</figure>
							</Button>
						</div>
					</div>        
					<div className="socials">
							<div >
								<Button onClick={(e) => {handleClick(e, "Mother");}}
									color="primary" >
									<figure>
									<img src={ic_add_mother_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
									<figcaption>Add Mother</figcaption>

									</figure>
								</Button>
							</div>
							<div >
								<Button onClick={(e) => {handleClick(e, "Wife");}}
							color="primary" >
								<figure>
								<img src={ic_add_wife_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
								<figcaption>Add Wife</figcaption>
								</figure>
								</Button>
							</div>
							<div >
								<Button onClick={(e) => {handleClick(e, "Sister");}}
							color="primary" >
								<figure>
								<img src={ic_add_sister_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
								<figcaption>Add Sister</figcaption>
								</figure>
							</Button>
							</div>
							<div >
						<Button onClick={(e) => {handleClick(e, "Daughter");}}
						color="primary" >
							<figure>
							<img src={ic_add_daughter_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
							<figcaption>Add Daughter</figcaption>
							</figure>
							</Button>
							</div>
						<div >
							<Button onClick={(e) => {handleClick(e, "remove");}}
						color="primary" >
							<figure>
						<img src={ic_add_brother_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
						<figcaption>Remove Member</figcaption>

						</figure>
						</Button>
						</div>
						<div >
							<Button onClick={(e) => {handleClick(e, "revoke_admin");}}
						color="primary" >
							<figure>
						<img src={ic_add_brother_popup} alt=""   style={{ width: '60px', height: '60px' }}/>
						<figcaption>Revoke admin access</figcaption>

						</figure>
						</Button>
						</div>
					</div>
			</div>
				</DialogActions>
			</Dialog>
			<ErrorDialog
			openErrrorDialog={openErrorDialog}
			setOpenErrorDialog={setOpenErrorDialog}
			ErrorMessage={ErrorMessage}
			/>
		</div>
	);
}
